module.exports = __webpack_public_path__ + "media/images/close-56571e120ae88c29614b97fad6f22266.svg";